export enum DMN_SITUACAO_RECAD {
  AGUARDANDO = "AGU",
  SOLICITADO = "SOL",
  EFETIVADO = "EFE",
  RECUSADO = "REC",
  BENEFICIO_SUSPENSO = "SUS",
  NAO_HA = "NA"
}

export type TYP_SITUACAO_RECAD = "AGU" | "SOL" | "EFE" | "REC" | "SUS";

export const BuscarNome = (codigo: TYP_SITUACAO_RECAD): string => {
  const situacoesPorNome = {
    "AGU": "AGUARDANDO RECADASTRAMENTO",
    "SOL": "RECADASTRAMENTO SOLICITADO",
    "EFE": "RECADASTRAMENTO EFETIVADO",
    "REC": "RECADASTRAMENTO RECUSADO",
    "SUS": "BENEFÍCIO SUSPENSO"
  }
  return situacoesPorNome[codigo];
};